/* Blocks "checkout" until the terms checkbox next to it is ticked (cart page and cart drawer). */
(function () {
  function box(button) {
    var scope = button.closest('.cart__footer, .cart-drawer__footer, .drawer__footer, .cart__blocks, form') || document;
    var found = scope.querySelector('[data-terms-agree]');
    if (!found) {
      var wrapper = button.closest('.cart__ctas');
      found = wrapper && wrapper.parentElement ? wrapper.parentElement.querySelector('[data-terms-agree]') : null;
    }
    return found || document.querySelector('[data-terms-agree]');
  }
  function block(e) {
    var button = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!button) return;
    var holder = box(button);
    if (!holder) return;
    var input = holder.querySelector('[data-terms-input]');
    if (input && !input.checked) {
      e.preventDefault();
      e.stopPropagation();
      var err = holder.querySelector('[data-terms-error]');
      if (err) err.hidden = false;
      input.focus();
    }
  }
  document.addEventListener('click', block, true);
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-terms-input]')) return;
    var err = e.target.closest('[data-terms-agree]').querySelector('[data-terms-error]');
    if (err && e.target.checked) err.hidden = true;
  });
})();
